import type {PartBool} from 'schemaDefinition/types';
import {evaluateFieldRequired} from 'schemaDefinition';
import type {ValidationArgs, ValidationResult} from './types';
import {fail} from './fail';
import {validResult} from './validResult';
import {validateConditions} from './validateConditions';
import {validateValueType} from './validateValueType';
import {warning} from './warning';

export const validateBool = (
  part: PartBool,
  args: ValidationArgs,
  aggregateResult: ValidationResult = validResult(),
): ValidationResult => {
  return validateValueType(
    part,
    validateSingleBoolValue,
    args,
    aggregateResult,
  );
};

export const validateSingleBoolValue = (
  part: PartBool,
  args: ValidationArgs,
  aggregateResult: ValidationResult = validResult(),
): ValidationResult => {
  // Unchecked (false/null/undefined) is considered missing
  if (!args.value) {
    const required = evaluateFieldRequired(
      part.required,
      args.valuePath,
      args.localScope,
      args.globalScope,
      args.relatedScope,
      args.value,
    );
    if (required) {
      return (required === true ? fail : warning)(
        {
          ...args,
          part,
          validation: 'required',
          messageKey: 'required',
        },
        aggregateResult,
      );
    }
  }

  if (
    args.value !== undefined &&
    args.value !== null &&
    typeof args.value !== 'boolean'
  ) {
    return fail(
      {
        ...args,
        part,
        validation: 'invalid_type',
        messageKey: 'invalid.type',
      },
      aggregateResult,
    );
  }

  if (part.validation) {
    return validateConditions(part.validation, part, args, aggregateResult);
  }

  return aggregateResult;
};
